module.exports = __webpack_public_path__ + "img/pichu.2d7e7a06.png";